import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function GuruDetail() {
  const { id } = useParams();
  const [guru, setGuru] = useState(null);

  useEffect(() => {
    const fetchGuru = async () => {
      const docRef = doc(db, "guruInfo", id);
      const snap = await getDoc(docRef);
      if (snap.exists()) setGuru(snap.data());
    };
    fetchGuru();
  }, [id]);

  if (!guru) return <p className="text-center mt-5">Memuat data guru...</p>;

  return (
    <div className="container mt-5">
      <Link to="/" className="btn btn-secondary mb-3">← Kembali</Link>
      <div className="row">
        <div className="col-md-4 text-center">
          <img src={guru.fotoUrl} alt={guru.nama} className="img-fluid rounded shadow" style={{ maxHeight: "400px", objectFit: "cover" }} />
          <h3 className="fw-bold mt-2">{guru.nama}</h3>
          <p className="text-muted">{guru.jabatan}</p>
        </div>
        <div className="col-md-8">
          <table className="table table-bordered">
            <tbody>
              <tr><th>Aktif Mulai</th><td>{guru.aktifMulai || "-"}</td></tr>
              <tr><th>Jabatan</th><td>{guru.jabatan || "-"}</td></tr>
              <tr><th>Status</th><td>{guru.status || "-"}</td></tr>
              <tr><th>Jenis Kelamin</th><td>{guru.jenisKelamin || "-"}</td></tr>
              <tr><th>T.T.L</th><td>{guru.ttl || "-"}</td></tr>
              <tr><th>Agama</th><td>{guru.agama || "-"}</td></tr>
              <tr><th>NIK</th><td>{guru.nik || "-"}</td></tr>
              <tr><th>NIP</th><td>{guru.nip || "-"}</td></tr>
              <tr><th>NUPTK</th><td>{guru.nuptk || "-"}</td></tr>
              <tr><th>Alamat</th><td>{guru.alamat || "-"}</td></tr>
              <tr><th>Profil Singkat</th><td>{guru.profilSingkat || "Belum ada data"}</td></tr>
              <tr><th>Pendidikan</th><td>{guru.pendidikan || "Belum ada data"}</td></tr>
              <tr><th>Pekerjaan</th><td>{guru.pekerjaan || "Belum ada data"}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
